import React, { Component } from 'react'
import intl from 'react-intl-universal'
import { inject, observer, PropTypes } from 'mobx-react'
import Page from './Page'
import AuthorisationHandler from '../components/AuthorisationHandler'
import ProfileMenu from '../components/ProfileMenu'
import Loading from '../components/Loading'
import VisibilitySensor from 'react-visibility-sensor'
import shortid from 'shortid'
import moment from 'moment/moment'

@inject('user', 'notifications')
@observer
class ProfileNotificationsPage extends Component {
  constructor (props) {
    super(props)

    const { user, notifications } = props
    const {token} = user
    notifications.get(token)
  }

  onChange = function (isVisible, id) {
    console.log('Element ' + id + ' is now %s', isVisible ? 'visible' : 'hidden')

    const { user, notifications } = this.props
    const { token } = user

    if (isVisible) {
      notifications.mark_as_read(token, id)
    }
  }

  render () {
    const { notifications } = this.props
    console.log('ProfileNotificationsPage.js - notifications:', notifications)

    let notifications_data = notifications.data

    return (
      <AuthorisationHandler>
        <Page title='Notifications'>
          <section className='b-profile'>
            <div className='b-profile-inner'>

              <ProfileMenu />

              <div className='b-profile-main'>
                <h3 className='b-profile-title'>Benachrichtigungen</h3>
                <hr />
                {!notifications.loaded
                  ? <div><Loading /></div>
                  : <div className='b-profile-block'>
                      <div className='b-profile-block-value'>
                        {notifications_data.length > 0
                          ? <div className='b-notifications'>
                              {notifications_data.map((notification, index) =>
                                <div key={shortid.generate()}
                                     className='b-notifications-notification'>
                                  {!notification.read &&
                                  <div className='b-notification-dot b-notification-dot_left' />
                                  }
                                  <div className='b-notifications-notification-text'>
                                    <VisibilitySensor
                                      onChange={(isVisible) => this.onChange(isVisible, notification.id)}
                                      delayedCall={true}
                                    />
                                    {notification.content}
                                  </div>
                                  <div className='b-notifications-notification-date'>
                                    {moment(notification.created_at).utc()/*.tz('Europe/Berlin')*/.format('DD.MM.YYYY')}
                                  </div>
                                </div>
                              )}
                            </div>
                          : <div className='b-empty'><div className='b-empty-text'>{intl.get('No notifications')}</div></div>
                        }
                      </div>
                    </div>
                }
              </div>
            </div>
          </section>
        </Page>
      </AuthorisationHandler>
    )
  }
}

ProfileNotificationsPage.propTypes = {
  user: PropTypes.observableObject,
  notifications: PropTypes.observableObject
}

export default ProfileNotificationsPage



// WEBPACK FOOTER //
// ./src/containers/ProfileNotificationsPage.js